import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;


export function getConnectedUsers(
  page,
  limit,
  fromDate = null,
  toDate = null,
  columnFilters = {}
) {
  const queryParams = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (fromDate && toDate) {
    queryParams.append("fromDate", fromDate);
    queryParams.append("toDate", toDate);
  }

  Object.keys(columnFilters || {}).forEach((key) => {
    const value = columnFilters[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      queryParams.append(key, String(value).trim());
    }
  });

  return axios.get(`${BASE_URL}/api/billing/connected-users?${queryParams.toString()}`);
}
